import {updateState} from './version.js';

function validManifest(value){
  return !!value
    && typeof value.latestVersion==='string'
    && typeof value.minimumSupportedVersion==='string';
}

export function createUpdateClient({currentVersion,endpoint='/api/release',fetchImpl=globalThis.fetch,manifestLoader,activeProcess=()=>false}={}){
  if(typeof currentVersion!=='string'||!currentVersion.trim())throw new TypeError('currentVersion is required');
  if(manifestLoader!==undefined&&typeof manifestLoader!=='function')throw new TypeError('manifestLoader must be a function');
  let lastManifest=null;

  async function loadFromEndpoint(){
    if(typeof fetchImpl!=='function')return null;
    const response=await fetchImpl(endpoint,{cache:'no-store',credentials:'omit',headers:{Accept:'application/json'}});
    if(!response?.ok)return null;
    return response.json();
  }

  async function check(){
    try{
      const manifest=manifestLoader?await manifestLoader():await loadFromEndpoint();
      if(!validManifest(manifest))return updateState(currentVersion,lastManifest);
      lastManifest=Object.freeze({
        latestVersion:String(manifest.latestVersion),
        minimumSupportedVersion:String(manifest.minimumSupportedVersion),
        message:String(manifest.message||''),
        storeUrl:String(manifest.storeUrl||''),
        platform:manifest.platform?String(manifest.platform):undefined
      });
      return updateState(currentVersion,lastManifest);
    }catch{return updateState(currentVersion,lastManifest);}
  }

  function mayActivateUpdate(){
    try{return !activeProcess();}catch{return false;}
  }

  return Object.freeze({check,mayActivateUpdate,getManifest:()=>lastManifest,getCurrentVersion:()=>currentVersion});
}
